export default __webpack_public_path__ + "20f19dacc34d366238326eaabbdfd26b.png";